var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgVideo = _a => {
  var _b, _c, _d;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3979 7.1387C22.6269 7.25654 22.7709 7.49247 22.7709 7.75V16.9167C22.7709 17.1742 22.6269 17.4101 22.3979 17.528C22.169 17.6458 21.8933 17.6258 21.6838 17.4761L15.2671 12.8928C15.0864 12.7637 14.9792 12.5554 14.9792 12.3333C14.9792 12.1113 15.0864 11.9029 15.2671 11.7739L21.6838 7.19056C21.8933 7.04088 22.169 7.02086 22.3979 7.1387ZM16.8495 12.3333L21.3959 15.5807V9.08595L16.8495 12.3333Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75002 6.60413C3.11719 6.60413 2.60419 7.11713 2.60419 7.74996V16.9166C2.60419 17.5495 3.11719 18.0625 3.75002 18.0625H13.8334C14.4662 18.0625 14.9792 17.5495 14.9792 16.9166V7.74996C14.9792 7.11713 14.4662 6.60413 13.8334 6.60413H3.75002ZM1.22919 7.74996C1.22919 6.35774 2.3578 5.22913 3.75002 5.22913H13.8334C15.2256 5.22913 16.3542 6.35774 16.3542 7.74996V16.9166C16.3542 18.3088 15.2256 19.4375 13.8334 19.4375H3.75002C2.3578 19.4375 1.22919 18.3088 1.22919 16.9166V7.74996Z",
    fill: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor'
  }));
};
export default SvgVideo;